"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearLocalToken = clearLocalToken;
exports.getLocalExpiresAt = getLocalExpiresAt;
exports.getLocalToken = getLocalToken;
exports.setLocalToken = setLocalToken;
var localToken = undefined;
var localExpiresAt = undefined;
var localStorageKey = 'tokenAndExpiry';
function isExpired(when) {
  return when.getTime() < new Date().getTime() - 60000; // 1 minute slack
}

function getLocalToken() {
  // console.log('getLocalToken', localToken)
  if (!localToken) {
    try {
      var item = window.localStorage.getItem(localStorageKey);
      if (item) {
        var _JSON$parse = JSON.parse(item),
          token = _JSON$parse.token,
          expiresAt = _JSON$parse.expiresAt;
        var expiresAtAsDate = new Date(expiresAt);
        if (!isExpired(expiresAtAsDate)) {
          localToken = token;
          localExpiresAt = expiresAtAsDate;
        }
      }
    } catch (e) {
      //  do nothing
    }
  }
  return localToken;
}
function getLocalExpiresAt() {
  return localExpiresAt;
}
function setLocalToken(token, expires_in) {
  var expiresAt = expires_in && new Date(new Date().getTime() + expires_in * 1000);
  console.log('setLocalToken', token, expiresAt);
  localToken = token;
  try {
    window.localStorage.setItem(localStorageKey, JSON.stringify({
      token: token,
      expiresAt: expiresAt
    }));
  } catch (e) {
    // do nothing
  }
}
function clearLocalToken() {
  console.log('revokeLocalToken');
  try {
    window.localStorage.removeItem(localStorageKey);
  } catch (e) {
    // do nothing
  }
}
//# sourceMappingURL=local-token.js.map